import { Avatar } from 'antd'
import { AvatarProps } from 'antd/lib/avatar/avatar'
import { isNumber } from 'lodash-es'
import React, { memo } from 'react'

interface OrbitAvatarProps extends AvatarProps {
  avatar: string
  name?: string
}

export default memo<OrbitAvatarProps>(function OrbitAvatar(props) {
  const { avatar, name, ...avatarProps } = props

  return (
    <>
      {avatar?.startsWith('#') ? (
        <Avatar {...avatarProps} style={{ color: '#fff', backgroundColor: avatar }}>
          <span style={{ fontSize: isNumber(avatarProps.size) ? `${(avatarProps.size as number) / 3}px` : '20px' }}>
            {name?.[0]?.toLocaleUpperCase()}
          </span>
        </Avatar>
      ) : (
        <Avatar {...avatarProps} src={avatar} />
      )}
    </>
  )
})
